import { cn } from '../../lib/utils';
import React from 'react'
import DatePicker from '../DatePicker'
import SearchBar from '../SearchBar'

export default function DataTableToolbar({
  searchValue,
  onSearchChange,
  planSearchValue,
  onPlanSearchChange,
  dateRange,
  onDateRangeChange,
  searchRef,
  planSearchRef,
  isDark = false,
  children, // Additional custom filters like Grouping Dropdowns
  searchPlaceholder = "Search...",
  planSearchPlaceholder = "Search by plan no.",
}) {
  const handleDateRangeChange = (start, end) => {
    onDateRangeChange?.(start, end)
  }

  return (
    <div className={cn("flex flex-col flex-wrap sm:flex-row items-stretch sm:items-center gap-[12px] sm:gap-[16px] w-full")}>
      <DatePicker
        intiStartDate={dateRange?.startDate}
        intiEndDate={dateRange?.endDate}
        onDateChange={handleDateRangeChange}
        isDark={isDark}
      />

      {children}

      <SearchBar
        value={searchValue}
        placeholder={searchPlaceholder}
        onSearch={onSearchChange}
        ref={searchRef}
        isDark={isDark}
        containerClassName="sm:w-[340px] ml-auto"
        minLength={1}
      />

      {onPlanSearchChange && (
        <SearchBar
          value={planSearchValue}
          placeholder={planSearchPlaceholder}
          onSearch={onPlanSearchChange}
          ref={planSearchRef}
          isDark={isDark}
          containerClassName="sm:w-[340px]"
          minLength={1}
        />
      )}
    </div>
  )
}
